import ButtonV2 from 'components/common/ButtonV2';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Col, Row } from 'reactstrap';

function DateRangeFilter({ onFilter, dateRange }) {
  const [startDate, setStartDate] = useState(dateRange?.startDate);
  const [endDate, setEndDate] = useState(dateRange?.endDate);

  useEffect(() => {
    setStartDate(dateRange?.startDate);
    setEndDate(dateRange?.endDate);
  }, [dateRange]);

  const handleSubmit = () => {
    // Trigger the filter callback
    onFilter({ startDate, endDate });
  };

  const getIsDisabled = () => {
    if (!startDate && !endDate) {
      return false; // Allows clearing an already applied filter
    }
    return !startDate; // A start date may be used as a single-date filter
  };

  return (
    <div className="notification-date-filter">
      <Row className="notification-date-row">
        <Col sm="2" className="notification-date-spacer" />
        <Col xs="12" sm="4" className="notification-date-col">
          <DatePicker
            selected={startDate}
            onChange={(date) => {
              setStartDate(date);
              if (endDate && date > endDate) {
                setEndDate(null); // Ensure end date is after start
              }
            }}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText="Start Date"
            isClearable
            dateFormat="dd-MM-yyyy"
          />
        </Col>
        <Col xs="12" sm="4" className="notification-date-col">
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText="End Date"
            isClearable
            dateFormat="dd-MM-yyyy"
          />
        </Col>
        <Col xs="12" sm="2" className="notification-date-actions">
          <ButtonV2
            color="primary"
            type="button"
            disabled={getIsDisabled()}
            onClick={handleSubmit}
          >
            Filter
          </ButtonV2>
        </Col>
      </Row>
    </div>
  );
}

export default DateRangeFilter;
